const AccessLevelOptions = [
  {
    label: "Require User Permission",
    value: 1,
  },
  {
    label: "No User Permission Required",
    value: 2,
  },
  {
    label: "Fully Trusted",
    value: 3,
  },
];

const IncludeChannelPreferencesOptions = [
  {
    label: "Never",
    value: 122,
  },
  {
    label: "Always",
    value: 123,
  },
  {
    label: "Create Only",
    value: 124,
  },
];

const AuditProfileChangesOptions = [
  {
    label: "Yes",
    value: true,
  },
  {
    label: "No",
    value: false,
  },
];

const emptyWarehouseApplication = {
  AccessLevel: 1,
  ApplicationId: null,
  AuditProfileChanges: false,
  ClientId: "",
  ClientSecret: "",
  HasClientSecret: false,
  IncludeChannelPreferences: 122,
  MatchKeySet: "",
  Name: "",
  Source: "",
};

function normalizeWarehouseApplication(application = {}) {
  return {
    ...emptyWarehouseApplication,
    ...application,
    AccessLevel: Number(application.AccessLevel || 1),
    AuditProfileChanges: Boolean(application.AuditProfileChanges),
    ClientSecret: "",
    HasClientSecret: Boolean(application.HasClientSecret),
    IncludeChannelPreferences: Number(
      application.IncludeChannelPreferences || 122
    ),
    MatchKeySet: Array.isArray(application.MatchKeySet)
      ? application.MatchKeySet.join(",")
      : application.MatchKeySet || "",
  };
}

function normalizeWarehouseApplications(applications) {
  return Array.isArray(applications)
    ? applications.map(normalizeWarehouseApplication)
    : [];
}

function createBlankWarehouseApplication() {
  return { ...emptyWarehouseApplication };
}

function parseMatchKeySet(value) {
  const matchKeySet = Array.isArray(value)
    ? value.join(",")
    : String(value || "");

  if (!matchKeySet.trim()) {
    return [];
  }

  return matchKeySet.split(",").map((token) => Number(token.trim()));
}

function validateWarehouseApplication(application, isCreate) {
  const errors = [];

  if (!application.ClientId.trim()) {
    errors.push("Client ID is required.");
  }

  if (isCreate && !application.ClientSecret.trim()) {
    errors.push("Client secret is required.");
  }

  if (
    application.MatchKeySet &&
    parseMatchKeySet(application.MatchKeySet).some((matchKeyId) => {
      return (
        !Number.isInteger(matchKeyId) ||
        matchKeyId <= 0
      );
    })
  ) {
    errors.push("Match key set must be a comma-separated list of ids.");
  }

  return errors;
}

function buildWarehouseApplicationPayload(application) {
  return {
    AccessLevel: Number(application.AccessLevel),
    AuditProfileChanges: Boolean(application.AuditProfileChanges),
    ClientId: application.ClientId,
    ClientSecret: application.ClientSecret,
    IncludeChannelPreferences: Number(
      application.IncludeChannelPreferences
    ),
    MatchKeySet: parseMatchKeySet(application.MatchKeySet),
    Name: application.ClientId,
    Source: application.Source,
  };
}

function getWarehouseApplicationCardDescription(application) {
  const accessLevel =
    AccessLevelOptions.find(
      (option) => option.value === Number(application.AccessLevel)
    )?.label || "Unknown access level";
  const includeChannelPreferences =
    IncludeChannelPreferencesOptions.find(
      (option) =>
        option.value === Number(application.IncludeChannelPreferences)
    )?.label || "Unknown channel preference";

  return `${accessLevel} - Channel preferences: ${includeChannelPreferences}`;
}

export {
  AccessLevelOptions,
  AuditProfileChangesOptions,
  IncludeChannelPreferencesOptions,
  buildWarehouseApplicationPayload,
  createBlankWarehouseApplication,
  getWarehouseApplicationCardDescription,
  normalizeWarehouseApplication,
  normalizeWarehouseApplications,
  validateWarehouseApplication,
};
